import { Job } from '../data/jobs';
import { MapPin, Briefcase, Calendar, DollarSign, Tag } from 'lucide-react';

interface JobCardProps {
  job: Job;
  onClick: (jobId: string) => void;
}

export function JobCard({ job, onClick }: JobCardProps) {
  const postedDate = new Date(job.posted);
  const now = new Date();
  const daysSincePosted = Math.floor((now.getTime() - postedDate.getTime()) / (1000 * 60 * 60 * 24));

  const tags = job.tags.split(',').map(tag => tag.trim());

  return (
    <button
      onClick={() => onClick(job.id)}
      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6 text-left border border-gray-100 hover:border-blue-300 cursor-pointer"
    >
      <div className="flex justify-between items-start mb-3">
        <div>
          <h3 className="text-xl font-bold text-gray-900 mb-1">{job.title}</h3>
          <p className="text-lg text-blue-600 font-semibold">{job.company}</p>
        </div>
        <span className="text-xs font-semibold text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
          {daysSincePosted === 0 ? 'Today' : daysSincePosted === 1 ? '1d ago' : `${daysSincePosted}d ago`}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-4 text-sm text-gray-600">
        <div className="flex items-center gap-2">
          <MapPin size={16} className="text-gray-400" />
          <span>{job.location}</span>
        </div>
        <div className="flex items-center gap-2">
          <Briefcase size={16} className="text-gray-400" />
          <span>{job.type}</span>
        </div>
        {/*
        <div className="flex items-center gap-2">
          <DollarSign size={16} className="text-gray-400" />
          <span>{job.salary}</span>
        </div>
        <div className="flex items-center gap-2">
          <Calendar size={16} className="text-gray-400" />
          <span>{job.experience}</span>
        </div>
        */}
      </div>

      <div className="flex flex-wrap gap-2">
        {tags.map((tag, idx) => (
          <span
            key={idx}
            className="inline-flex items-center gap-1 text-xs bg-blue-50 text-blue-700 px-2.5 py-1 rounded-full"
          >
            <Tag size={12} />
            {tag}
          </span>
        ))}
      </div>

      <div className="mt-4 pt-4 border-t border-gray-100 text-blue-600 font-semibold text-sm">
        Ver Detalles →
      </div>
    </button>
  );
}
